import '../styles/vut.css';
import vutimg from 'url:../assets/vut/vut-clsd.png';

export function VUT () {
    return <div className="page-basic center-all bg-black text-white">
        <div className="h-box width-100p height-512 vut-bg center-all">
            <img src={vutimg} className='width-384 height-384' />
        </div>
    </div>
}